export default __webpack_public_path__ + "static/media/1985.286f23a3.png";